// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill' //解决ie 兼容
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import utils from "./assets/common/utils"//公共的js文件
// import 'animate.css';
import Bus from './assets/common/bus' // bus 存储
import 'es6-promise'
import 'es6-object-assign'

import VueAwesomeSwiper from 'vue-awesome-swiper'

// import mergeRequest from "./assets/common/mergeRequest"//整合方法（首页与二级页面同一个接口的）
import {
  Tabs, TabPane, Carousel, CarouselItem, Dialog, Breadcrumb, BreadcrumbItem,
  Pagination, Popover, Dropdown, DropdownMenu, DropdownItem, Row, Col, Radio, Input, Button,
  Checkbox, CheckboxGroup, Message, MessageBox, Upload, Select, Option, Tooltip, Form, FormItem,
  Notification,
} from 'element-ui';


Vue.use(VueAwesomeSwiper);

Vue.config.productionTip = false
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Carousel);//轮播图
Vue.use(CarouselItem);
Vue.use(Dialog);//弹窗
Vue.use(Breadcrumb);//弹窗
Vue.use(BreadcrumbItem);//弹窗
Vue.use(Pagination);//分页
Vue.use(Popover);//弹出框
Vue.use(Dropdown);//下拉菜单
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Row);//Row
Vue.use(Col);//Col
Vue.use(Radio);//单选框
Vue.use(Input);//输入框
Vue.use(Button);//按钮
Vue.use(Checkbox);//复选框
Vue.use(CheckboxGroup);//复选框组
Vue.use(Upload);//上传插件
Vue.use(Select);//select 选择框
Vue.use(Option);//option 选择框
Vue.use(Tooltip);//Tooltip 文字提示
Vue.use(Form);//表单
Vue.use(FormItem);
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$notify = Notification;
// Vue.prototype.$alert = MessageBox.alert;//提示框

Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
Vue.prototype.$utils = utils;
Vue.prototype.$bus = Bus
// Vue.prototype.$mergeRequest = mergeRequest;

Vue.prototype.$message = Message;


Vue.prototype.$addStorageEvent = function (type, key, data) {
  if (type === 1) {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
      setItem: function (k, val) {
        localStorage.setItem(k, val);
        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
        // 派发对象
        window.dispatchEvent(newStorageEvent);
      }
    }
    return storage.setItem(key, data);
  } else {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
      setItem: function (k, val) {
        sessionStorage.setItem(k, val);
        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
        // 派发对象
        window.dispatchEvent(newStorageEvent);
      }
    }
    return storage.setItem(key, data);
  }
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js